import React from 'react';

import { Box, Skeleton, Stack } from '@mui/material';

import { COLOR } from '../../../helpers/colors';

const textBox = (
  <Skeleton
    variant="text"
    color={COLOR.PH}
    style={{
      width: '25%',
    }}
    animation="wave"
  />
);
const FavoritePlaceholder = () => (
  <Box
    sx={{
      marginY: 6,
      border: `1px solid ${COLOR.borderColor}`,
      borderRadius: 1,
    }}
  >
    <Stack
      direction="row"
      justifyContent="space-between"
      spacing={8}
      sx={{ borderBottom: `1px solid ${COLOR.borderColor}`, p: 2 }}
    >
      {textBox}
      {textBox}
    </Stack>
    <Stack
      direction="row"
      justifyContent="space-between"
      spacing={8}
      sx={{ borderBottom: `1px solid ${COLOR.borderColor}`, p: 2 }}
    >
      {textBox}
      {textBox}
      {textBox}
    </Stack>
    <Stack direction="row" justifyContent="space-between" sx={{ m: 2 }} alignItems="center">
      {textBox}
      {textBox}
      {textBox}
    </Stack>
  </Box>
);

export default FavoritePlaceholder;
